import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from '@/App.vue';
import EmailSearch from '@/views/EmailSearch.vue';
import Smarthosts from '@/views/Smarthosts.vue';
import DomainKeys from '@/views/DomainKeys.vue';
import BlockedRecipients from '@/views/BlockedRecipients.vue';
import { formatDate } from '@/filters/formatDate';

import '@/styles/bulma.scss';
import '@/styles/global.scss';

const KWS_REDIRECT_URL = process.env.VUE_APP_KWS_REDIRECT_URL;
if (KWS_REDIRECT_URL && window.parent === window) {
  window.location.replace(KWS_REDIRECT_URL);
} else {
  const app = createApp(App);
  app.use(createRouter({
    history: createWebHistory(),
    routes: [
      {
        path: '/',
        alias: '/email',
        name: 'EmailSearch',
        component: EmailSearch
      },

      {
        path: '/smarthosts',
        name: 'Smarthosts',
        component: Smarthosts
      },

      {
        path: '/domainkeys',
        name: 'DomainKeys',
        component: DomainKeys
      },

      {
        path: '/blockedRecipients',
        name: 'BlockedRecipients',
        component: BlockedRecipients
      }
    ]
  })).mount('#app');

  app.config.globalProperties.$filters = {
    formatDate
  };

  app.config.performance = true;
}

